import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class CallCenterModeService {
  private callCenterModeActive = new BehaviorSubject<boolean>(false);

  constructor(private router: Router) {
    // Listen to Router events to make sure we catch the correct URL after navigation
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      // Check for boolean value in session storage
      const callCenterMode = sessionStorage.getItem('call_center_mode') === 'true';
      if (callCenterMode) {
        this.setMode(true);
      }
    });
  }

  setMode(active: boolean, navigate = true) {
    this.callCenterModeActive.next(active);

    if (active) {
      sessionStorage.setItem('call_center_mode', 'true');

      // Check if the current URL is already the desired one
      const currentUrl = this.router.url.split('?')[0];
      if (navigate && !currentUrl.includes('/call-center/app')) {
        this.router.navigateByUrl('/call-center/app');
      }
    } else {
      sessionStorage.removeItem('call_center_mode');
      if (navigate) {
        this.router.navigateByUrl('/brand');
      }
    }
  }

  getIsActive() {
    return this.callCenterModeActive.asObservable();
  }
}
